import { splitArray } from 'utils/arrayHelpers';
import { isDefined, isString } from 'utils/tsHelpers';
import { createNewOption } from './createNewOption';
import { BaseOption } from '../types';

export const getCreatedAndSelectedOptions = (
  options: BaseOption[],
  values: string[],
  canCreate: boolean,
) => {
  // split values to selected values and new values
  const [selectedValues, createdValues] = splitArray(
    values,
    (value) =>
      options
        .filter(({ label }) => isString(label)) // filter labels with string labels
        .map(({ label }) => label) // map to just labels
        .includes(value), // check if value is one of them
  );

  const createdOptions = canCreate ? createdValues.map(createNewOption) : [];

  const selectedOptions = selectedValues
    .map((value) => options.find(({ label }) => label === value))
    .filter(isDefined);

  return [selectedOptions, createdOptions];
};
